// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3BqOc","colMin":"styles_colMin__1EeVj","colCheckbox":"styles_colCheckbox__2OLIK"};